/**
 * Generated from ch6_p01.fla
 */
export function ch6_p01(this: Ich6_p01) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2.call(rain[0] as Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 320;
		rain[0].width = 1641.00;
		rain[0].height = 640.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1.call(rain[1] as Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 366.25;
		rain[1].width = 1600.50;
		rain[1].height = 732.50;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const bushes = this.bushes;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bushes.call(this.bushes);
	bushes.x = 832;
	bushes.y = 464;
	bushes.width = 1664.00;
	bushes.height = 455.00;
	bushes.alpha = 1.00;
	if (bushes.onLayout) bushes.onLayout();
	const path = this.path;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_path.call(this.path);
	path.x = 832;
	path.y = 691.5;
	path.width = 1664.00;
	path.height = 153.00;
	path.alpha = 1.00;
	if (path.onLayout) path.onLayout();
	const tree = this.tree;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_maintree.call(this.tree);
	tree.x = 835.25;
	tree.y = 346.25;
	tree.width = 1002.50;
	tree.height = 692.50;
	tree.alpha = 1.00;
	if (tree.onLayout) tree.onLayout();
	const horse = this.horse;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_horse.call(this.horse);
	horse.x = 639.5;
	horse.y = 443.5;
	horse.width = 337.00;
	horse.height = 538.00;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_holly.call(this.holly);
	holly.x = 731.5;
	holly.y = 487.75;
	holly.width = 104.00;
	holly.height = 457.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const tyler = this.tyler;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_tyler.call(this.tyler);
	tyler.x = 879.5;
	tyler.y = 470.5;
	tyler.width = 132.00;
	tyler.height = 494.00;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const frameRight = this.frameRight;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframerlineas.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 571;
	linesRight.width = 98.00;
	linesRight.height = 152.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 479.5;
	linesLeft.width = 76.50;
	linesLeft.height = 337.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bg(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bushes(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_bushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_path(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_path) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_path", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_maintree(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_maintree) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_maintree", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_horse(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_horse", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_holly(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_tyler(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p01_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeRframe(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframerlineas(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframerlineas) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlineas", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeLframe(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframellines(this: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p01Sprite extends Ich6_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p01Text extends Ich6_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p01Polygon extends Array<number> {
}
interface Ich6_p01 {
	readonly rain: Ich6_p01Array<Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2|Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1>;
	readonly bg: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bg;
	readonly bushes: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bushes;
	readonly path: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_path;
	readonly tree: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_maintree;
	readonly horse: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_horse;
	readonly holly: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_holly;
	readonly tyler: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_tyler;
	readonly frameRight: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeRframe;
	readonly linesRight: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframerlineas;
	readonly frameLeft: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeLframe;
	readonly linesLeft: Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframellines;
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bg extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_bushes extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_path extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_maintree extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_horse extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_holly extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_tyler extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain2 extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1rainoverlayrain1 extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeRframe extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframerlineas extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframeLframe extends Ich6_p01Sprite {
}
interface Ich6_p01_hh_ch6_72dpi_p01psdAssetp1chp6_p01_wcframellines extends Ich6_p01Sprite {
}
